import { memo } from "react";
import PropTypes from "prop-types";
import { NavigationControl, ScaleControl, Map } from "react-map-gl";
import LayerControl from "../LayerControl/LayerControl";
import "../Navix.css";

/**
 * MapContainer component for the map display
 */
const MapContainer = ({
  mapRef,
  mapboxToken,
  handleMapLoad,
  toggleLayer,
  isLayerLoading,
  loadingLayerName,
  fitMapToBounds,
  isAuthenticated,
  setShowAuthDialog,
  children,
}) => {
  return (
    <div className="county-hero-image">
      <Map
        ref={mapRef}
        initialViewState={{
          longitude: -99.33, // Center of Texas
          latitude: 31.47, // Center of Texas
          zoom: 5.8, // A comfortable state-wide view
          minZoom: 5, // Prevent zooming out too far
          maxZoom: 12, // Prevent zooming in too close
        }}
        style={{ width: "100%", height: "100%" }}
        mapStyle="mapbox://styles/mapbox/streets-v12"
        mapboxAccessToken={mapboxToken}
        onLoad={handleMapLoad}
      >
        <NavigationControl position="top-left" />
        <ScaleControl position="bottom-left" />

        {/* Fit to Bounds button */}
        <button
          className="fit-bounds-button"
          onClick={() => {
            console.log("Fit bounds button clicked");
            fitMapToBounds();
          }}
          title="Fit to visible layers"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"></path>
          </svg>
        </button>
        {/* Added a higher z-index to ensure the layer control is clickable */}
        <div style={{ position: "relative", zIndex: 1001 }}>
          <LayerControl
            onToggleLayer={toggleLayer}
            isAuthenticated={isAuthenticated}
            setShowAuthDialog={setShowAuthDialog}
            isLayerLoading={isLayerLoading}
          />
        </div>
        {/* Loading indicators with improved visibility */}
        {isLayerLoading && (
          <div
            className="map-loading-indicator"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          >
            <span>Fetching {loadingLayerName} Information</span>
            <div className="loading-dots">
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
            </div>
          </div>
        )}

        {children}
      </Map>
    </div>
  );
};

MapContainer.displayName = "MapContainer";

MapContainer.propTypes = {
  mapRef: PropTypes.object,
  mapboxToken: PropTypes.string,
  handleMapLoad: PropTypes.func,
  toggleLayer: PropTypes.func,
  isLayerLoading: PropTypes.bool,
  loadingLayerName: PropTypes.string,
  fitMapToBounds: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  setShowAuthDialog: PropTypes.func,
  children: PropTypes.node,
};

export default memo(MapContainer);
